import Head from "next/head";
import styles from "../styles/Home.module.css";
import Srcset from "@/components/common/Srcset";
import { BuilderComponent } from "@builder.io/react";
import { useEffect,useState } from "react";
import { setMenuData } from "@/redux/actions/generalAction";
import { useDispatch } from "react-redux";
import { useRouter } from "next/compat/router";
import { getPageData } from "@/utils/getSeoMenu";
import { useSelector } from "react-redux";
import {
  viewFrontPage,
} from "@/components/common/Nosto";
import { fetchBuilderContent } from "@/utils/pages"

import { getNumberId } from "@/helpers/wishlistHelpers";
import { removeTargetAttr } from "@/helpers/generalHelper";

export async function getServerSideProps() {
  //fetch menuElement directly from pages
  const content = await getPageData('/')
  // const isMobile = req.rawHeaders.some(item => item.includes(substring));
  const menuElement = await fetchBuilderContent(false,"/",'menuElement');
  return {
    props: { content, menuElement },
    notFound: !content,
  };
};

export default function Home(props) {
  const router = useRouter();
  const [pageLoaded, setPageLoaded] = useState(false);
  //logged in state for yotpo sticky bottom banner homepage only
  let logUser = useSelector((state) => state.loginUser);
  const userId = logUser.userData?.id;
  let customer = logUser?.userData;
  let customerId;
  if (userId) {
    const cId = Buffer.from(userId, "base64").toString("ascii");
    customerId = getNumberId(cId);
  }
  const isPWA = useSelector((state) => state.pwa.is_PWA);

  useEffect(() => {
    let routerPath = router.pathname;
    if (routerPath === "/[...pages]") {
      routerPath = router.query.pages.join('/');
    }
    viewFrontPage();
    setPageLoaded(true);
  }, [router]);

  useEffect(() => {
    if (pageLoaded) {
      removeTargetAttr();
    }
  },[pageLoaded])
  
  const dispatch = useDispatch();
  if (props.menuElement) {
    dispatch(setMenuData(JSON.stringify(props.menuElement)));
  }

  if (props.content) {
    const page = props.content;
    let pageTitle = "",
      seoPageTitle = "",
      seoDescription = "";
    if (
      page != undefined &&
      page.data != undefined &&
      page.data.pageTitle != undefined
    ) {
      pageTitle = page.data.pageTitle;
      seoPageTitle =
        page.data.seoPageTitle === undefined ||
          page.data.seoPageTitle === null ||
          page.data.seoPageTitle.trim() == ""
          ? pageTitle
          : page.data.seoPageTitle;
      seoDescription =
        page.data.seoDescription === undefined ||
          page.data.seoDescription === null ||
          page.data.seoDescription.trim() == ""
          ? pageTitle
          : page.data.seoDescription;
    }

    return (
      <>
        {/* Render the Builder page */}
        <Head>
          <title>{pageTitle}</title>
          <meta name="title" content={seoPageTitle} />
          <meta name="description" content={seoDescription} />
          <meta property="og:title" content={seoPageTitle}></meta>
          <meta property="og:description" content={seoDescription}></meta>
          <meta property="og:url" content={process.env.NETLIFY_URL}></meta>
          <meta property="og:image" content={`${process.env.NETLIFY_URL}/${process.env.OG_IMAGE_PATH}`}></meta>
          <meta property="og:image:secure_url" content={`${process.env.NETLIFY_URL}/${process.env.OG_IMAGE_PATH}`}></meta>
          <meta property="og:image:width" content="1200"></meta>
          <meta property="og:image:height" content="628"></meta>
        </Head>
        <BuilderComponent model="page" content={page} />
        {/* {
          userId && <div id="swell-customer-identification" data-authenticated="true"
          data-email={customer.email}
          data-id={customerId}
          data-tags={JSON.stringify(customer.tags)}
          style={{ display: 'none' }}>
        </div>
        } */}
      </>
    );
  } else {
    return (
      <div className={styles.container}>
        <Head>
          <title>Luxury shopping with purpose | Olivela</title>
          <meta
            name="description"
            content="Shop Women'&#039;'s Designer Clothing, Shoes, Bags &amp; Beauty | Olivela.com"
          />
          <meta
            name="description"
            content="Luxury shopping with purpose | Olivela"
          />
          <link rel="icon" href="/favicon.ico" />
        </Head>
        <main className={styles.main}>
          <h1 className={styles.title}>
            Welcome to <a href="https://nextjs.org"></a>
          </h1>
          <Srcset
            svgFile={true}
            src="images/web/logos/olivela-logo-svg.svg"
            requirePath={true}
            width={300}
            height={100}
            alt="Vercel Logo"
          />{" "}
        </main>
        <footer className={styles.footer}>
          <a
            href="https://www.olivela.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            Powered by{" "}
            <span className={styles.logo}>
              <Srcset
                svgFile={true}
                src="images/web/logos/olivela-logo-svg.svg"
                requirePath={true}
                width={72}
                height={16}
                alt="Olivela"
              />
            </span>
          </a>
        </footer>
      </div>
    );
  }
}
